import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'om-switch',
  templateUrl: './om-switch.component.html',
  styleUrls: ['./om-switch.component.scss']
})
export class OmSwitchComponent implements OnInit, OnChanges, OnDestroy {

  @Input() control: FormControl;
  @Input() placeholder = '';
  @Input() orientation: 'vertical' | 'horizontal' = 'vertical';

  @Input() label: string;
  @Input() icon: string;

  private controlChanged$ = new Subject<void>();

  isRequired$ = new BehaviorSubject<boolean>(false);

  constructor() { }

  ngOnInit(): void {
    this.control = this.control ?? new FormControl('');
    this.isRequired$.next(this.control.hasValidator(Validators.required));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.control && !changes.control.firstChange) {
      this.isRequired$.next(changes.control.currentValue.hasValidator(Validators.required));
    }
  }

  ngOnDestroy(): void {
    this.controlChanged$.next();
    this.controlChanged$.complete();
  }
}
